import { makeRequest } from 'utils/requestLogger';

export default (payload) => makeRequest('post', `/api/recaps/`, payload);


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/recap/createGenieRecap.js